import React, { useState } from "react";
import Action from "../../../commons/Action";
import { ExpandLess } from "../../../assets/svg/AllSvg";
import moment from "moment";

const AccordionIndividualService = ({ element, setIsId }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <tr
        className={
          "border-b table_responsive_text hover:bg-secondary_light_shades"
        }
        key={element?.id}
      >
        <td className="px-5 py-3 truncate capitalize">
          {element?.type === "service_request"
            ? element?.type.replace("_", " ")
            : element?.type}
        </td>
        <td className="px-5 py-3 truncate">{`$${element?.price} / ${element?.duration}`}</td>
        <td className="px-5 py-3 truncate">
          {element.start_date
            ? moment(element?.start_date).format("DD/MM/YYYY ")
            : ""}
          -
          {element.end_date
            ? moment(element?.end_date).format(" DD/MM/YYYY")
            : ""}
        </td>
        <td className="px-5 py-3">
          <div className="flex items-center space-x-2">
            <Action
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center lg:px-6 sm:px-5 px-4 lg:py-2 py-1 bg-white hover:bg-secondary_light_shades transition duration-300 cursor-pointer"
                    onClick={() => {
                      setIsId(element?.id);
                    }}
                  >
                    View
                  </li>
                </>
              }
            />
            <button
              type="button"
              className={isOpen ? "rotate-0" : "rotate-180"}
              onClick={() => setIsOpen(!isOpen)}
            >
              <ExpandLess pathClass={"fill-secondary_lightGrey"} />
            </button>
          </div>
        </td>
      </tr>
      {isOpen ? (
        <>
          <tr className="bg-primary_shades_light">
            <td className="px-5 py-3" colspan="4">
              {element?.request}
            </td>
          </tr>
          <tr className="bg-lightPrimaryShades">
            <td className="px-8 py-2">Billing Cycle</td>
            <td className="px-8 py-2" colspan="3">
              {`$${element?.price} / ${element?.duration}`}
            </td>
          </tr>
          <tr className="bg-lightPrimaryShades">
            <td className="px-8 py-2">Date of Purchase</td>
            <td className="px-8 py-2" colspan="3">
              {element.start_date
                ? moment(element?.start_date).format("DD MMM YYYY ")
                : ""}
            </td>
          </tr>
          <tr className="bg-lightPrimaryShades">
            <td className="px-8 py-2">Service Period</td>
            <td className="px-8 py-2" colspan="3">
              {element.start_date
                ? moment(element?.start_date).format("DD MMM YYYY ")
                : ""}
              -
              {element.end_date
                ? moment(element?.end_date).format(" DD MMM YYYY")
                : ""}
            </td>
          </tr>
          <tr className="bg-lightPrimaryShades border-b">
            <td className="px-8 py-2">Status</td>
            <td className="px-8 py-2 capitalize" colspan="3">
              {element?.status}
            </td>
          </tr>
        </>
      ) : null}
    </>
  );
};

export default AccordionIndividualService;
